import { useState } from 'react';
import '../Styles/industry.css';
import JoinModal from '../components/JoinModel';

function Industry() {
  const [isJoinOpen, setIsJoinOpen] = useState(false);

  return (
    <>
      {/* ===================================================
          SECTION 1: INDUSTRY-ACADEMIA CONNECT (SPLIT LEFT / RIGHT)
      =================================================== */}
      <section className="industry-hero">
        <div className="industry-hero-container">
          {/* LEFT — badge, heading, subtitle, button */}
          <div className="industry-hero-left">
            <span className="industry-hero-badge">Industry–Academia Connect</span>

            <h1 className="industry-hero-title">
              Building Stronger Connections Between{' '}
              <span className="industry-hero-title-highlight">Education</span> and
              Industry
            </h1>

            <p className="industry-hero-subtitle">
              Industry–Academia Connect is a flagship initiative by Vanakkam HRD dedicated to bridging the gap between educational institutions and the corporate world. Our platform creates meaningful collaborations between colleges, universities, HR leaders, organizations, and students to develop future-ready talent equipped with industry-relevant skills.
            </p>

            <p className="industry-hero-subtitle">
              By connecting academia with experienced HR professionals and business leaders, we help students gain practical exposure, enhance employability, and prepare for successful careers while enabling organizations to access emerging talent.
            </p>

            <button
              type="button"
              className="industry-hero-btn"
              onClick={() => setIsJoinOpen(true)}
            >
              Become a Member
              <img
                src="/assets/About_arrow_icon.png"
                alt="Arrow Icon"
                className="industry-arrow-icon"
              />
            </button>
          </div>

          {/* RIGHT — image */}
          <div className="industry-hero-right">
            <div className="industry-hero-img-wrap">
              <div className="industry-hero-img-accent"></div>
              <img
                src="/assets/industry_image_1.png"
                alt="Industry and academia professionals collaborating"
                className="industry-hero-img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ===================================================
          SECTION 2: WHAT WE OFFER
      =================================================== */}
      <section className="industry-offer-section">
        <div className="industry-offer-container">
          <h2 className="industry-offer-heading">What We Offer</h2>
          <p className="industry-offer-subtitle">
            Whether you are an educational institution, corporate organization, HR leader, or industry expert, Industry–Academia Connect welcomes you to collaborate in building a stronger, more skilled, and future-ready workforce.
          </p>

          <div className="industry-offer-grid">
            <div className="industry-offer-card">
              <div className="industry-offer-icon">
            <img
                src="/assets/industry_icon_1.png"
                alt="Industry Icon 1"
                className="industry-offer-icon-img"
            />
            </div>
              <h3 className="industry-offer-card-title">
                Campus Engagement Programs
              </h3>
              <p className="industry-offer-card-desc">
                Interactive sessions, HR conclaves, leadership talks, and career
                guidance programs conducted by experienced HR leaders and
                industry experts.Interactive sessions, HR conclaves, leadership talks, and career guidance programs conducted by experienced HR leaders and industry experts.
              </p>
            </div>

            <div className="industry-offer-card">
              <div className="industry-offer-icon">
            <img
                src="/assets/industry_icon_2.png"
                alt="Industry Icon 2"
                className="industry-offer-icon-img"
            />
            </div>
              <h3 className="industry-offer-card-title">
                Industry Expert Sessions
              </h3>
              <p className="industry-offer-card-desc">
                Knowledge-sharing sessions covering HR trends, leadership, AI in HR, workplace culture, employability skills, and career development.
              </p>
            </div>

            <div className="industry-offer-card">
              <div className="industry-offer-icon">
                <img
                  src="/assets/industry_icon_3.png"
                  alt="Internship and Placement Support Icon"
                  className="industry-offer-icon-img"
                />
              </div>
              <h3 className="industry-offer-card-title">
                Internship &amp; Placement Support
              </h3>
              <p className="industry-offer-card-desc">
                Connecting organizations with colleges to facilitate internships, live projects, campus recruitment, and placement opportunities.
              </p>
            </div>

            <div className="industry-offer-card">
              <div className="industry-offer-icon">
                <img
                  src="/assets/industry_icon_4.png"
                  alt="Faculty and Industry Collaboration Icon"
                  className="industry-offer-icon-img"
                />
              </div>
              <h3 className="industry-offer-card-title">
                Faculty &amp; Industry Collaboration
              </h3>
              <p className="industry-offer-card-desc">
                Encouraging partnerships between educators and industry experts for curriculum enhancement, research, and practical learning.
              </p>
            </div>

            <div className="industry-offer-card">
              <div className="industry-offer-icon">
                <img
                    src="/assets/industry_icon_5.png"
                    alt="Industry Icon 5"
                    className="industry-offer-icon-img"
                />
                </div>
              <h3 className="industry-offer-card-title">
                HR Leadership Mentorship
              </h3>
              <p className="industry-offer-card-desc">
               Providing mentorship opportunities where experienced HR leaders guide students and young professionals in career planning and professional development.
              </p>
            </div>

            <div className="industry-offer-card">
              <div className="industry-offer-icon">
                <img
                  src="/assets/industry_icon_6.png"
                  alt="Skill Development Workshops Icon"
                  className="industry-offer-icon-img"
                />
              </div>
              <h3 className="industry-offer-card-title">
                Skill Development Workshops
              </h3>
              <p className="industry-offer-card-desc">
                Hands-on workshops focused on communication, leadership, interview preparation, workplace readiness, design thinking, digital HR, and emerging technologies.
              </p>
            </div>
          </div>
        </div>
      </section>

      <JoinModal isOpen={isJoinOpen} onClose={() => setIsJoinOpen(false)} />
    </>
  );
}

export default Industry;
